import {AsyncCacheMap} from "@common/helpers/async-cache-map/async-cache-map"
import {Observable} from "rxjs"
import {DataNodes} from "@cm/render-nodes"
import {hashObject} from "@cm/utils"

export class BaseGeometryDataCache<GeometryGraph extends object, EvaluatedGeometryData> {
    protected cache: AsyncCacheMap<string, EvaluatedGeometryData, [GeometryGraph, DataNodes.EvaluationResources]>

    constructor(evaluateFn: (graph: GeometryGraph, resources: DataNodes.EvaluationResources) => Observable<EvaluatedGeometryData>) {
        this.cache = new AsyncCacheMap((key, [graph, resources]) => {
            return evaluateFn(graph, resources)
        })
    }

    getIfCached(graph: GeometryGraph): EvaluatedGeometryData | null {
        return this.cache.getSync(hashObject(graph)) ?? null
    }

    invalidate() {
        this.cache.clear()
    }
}
